import { configureStore, combineReducers } from "@reduxjs/toolkit";
import businessSlice from "./reducers/businessSlice";
import customerSlice from "./reducers/customerSlice";
import invoiceSlice from "./reducers/invoiceSlice";
import productSlice from "./reducers/productSlice";
import appointmentSlice from "./reducers/appointmentSlice";
import taxSlice from "./reducers/taxSlice";
import discountSlice from "./reducers/discountSlice";
import authSlice from "./reducers/authSlice";
import transactionSlice from "./reducers/transactionSlice";
import subscriptionSlice from "./reducers/subscriptionSlice";
import shipmentSlice from "./reducers/shipmentSlice";
import portalAuthSlice from "./reducers/portalAuthSlice";
import portalCartSlice from "./reducers/portalCartSlice";
import portalOrderSlice from "./reducers/portalOrderSlice";
import orderSlice from "./reducers/orderSlice";
import communicationSlice from "./reducers/communicationSlice";
import invitationSlice from "./reducers/invitationSlice";

const appReducer = combineReducers({
  auth: authSlice,
  product: productSlice,
  customer: customerSlice,
  invoice: invoiceSlice,
  business: businessSlice,
  appointment: appointmentSlice,
  tax: taxSlice,
  discount: discountSlice,
  transaction: transactionSlice,
  subscription: subscriptionSlice,
  shipment: shipmentSlice,
  portalAuth: portalAuthSlice,
  portalCart: portalCartSlice,
  portalOrder: portalOrderSlice,
  order: orderSlice,
  communication: communicationSlice,
  invitation: invitationSlice,
});

const rootReducer = (state, action) => {
  if (action.type === "auth/logout") {
    // Clear Redux state by setting to undefined so slices revert to initial state
    state = undefined;
  }
  return appReducer(state, action);
};

const store = configureStore({
  reducer: rootReducer,
});

export default store;
